module.exports = __webpack_public_path__ + "static/media/BrownMagicalUs.b72662dd.jpg";